import React from "react";
import {
  Container,
  Header,
  SpaceBetween,
  Grid,
  Button,
  Alert,
  Box,
} from "@amzn/awsui-components-react";
import { WizardConfig } from "../generic-draft-wizard";
import CreateEditGaiaobjectForm from "../create-edit-gaiaobject-form/CreateEditGaiaobjectForm";
import { FilePreview } from "../file-preview/FilePreview";
import AssessmentDetailsStep from "../assessment-details-step/AssessmentDetailsStep";

export const createNoticeWizardConfig = (
  onComplete: (stepData: any) => Promise<void>,
  onCancel: () => void,
  scanJobData?: any,
  downloadUrlData?: any,
  shortId?: string,
  onStepValidationSuccess?: (data: any) => void,
  triggerWizardValidationCounter?: number,
  triggerFormValidation?: () => void,
  formRef?: React.RefObject<any>,
  isFilePreviewVisible?: boolean,
  setIsFilePreviewVisible?: (visible: boolean) => void,
  isAssessmentSimplified?: boolean,
  setIsAssessmentSimplified?: (value: boolean) => void,
  control?: any
): WizardConfig => {
  return {
    category: "notice",
    submitButtonText: "Create",
    cancelButtonText: "Cancel",
    onComplete,
    onCancel,
    steps: [
      {
        title: "Notice Details",
        description: (
          <>
            <br />
            Fill in the notice information below. The form will be pre-populated
            with default values.
          </>
        ),
        validateWizardStep: async () => {
          return true;
        },
        triggerFormValidation,
        content: (
          <SpaceBetween size="m">
            <SpaceBetween direction="horizontal" size="xs">
              <Button
                variant="link"
                iconName={
                  isFilePreviewVisible ? "view-horizontal" : "view-full"
                }
                onClick={() => setIsFilePreviewVisible?.(!isFilePreviewVisible)}
              >
                {isFilePreviewVisible ? "Hide" : "Show"} File Preview
              </Button>
            </SpaceBetween>
            <Grid
              gridDefinition={
                isFilePreviewVisible
                  ? [{ colspan: 6 }, { colspan: 6 }]
                  : [{ colspan: 12 }]
              }
            >
              {isFilePreviewVisible && (
                <Container header={<Header variant="h2">File Preview</Header>}>
                  {scanJobData?.scanJob ? (
                    <FilePreview
                      type={"pdf"}
                      fileName={scanJobData.scanJob.fileName}
                      presignedUrl={downloadUrlData?.url || ""}
                    />
                  ) : (
                    <div>No file available for preview</div>
                  )}
                </Container>
              )}
              <CreateEditGaiaobjectForm
                ref={formRef}
                type="notice"
                mode="draft"
                shortId={shortId}
                wizardMode={true}
                onWizardValidationSuccess={onStepValidationSuccess}
                triggerWizardValidation={triggerWizardValidationCounter || 0}
              />
            </Grid>
          </SpaceBetween>
        ),
      },
      {
        title: "Create Assessment",
        description:
          "Create a preliminary assessment based on the notice scan data",
        content: !shortId ? (
          <Alert type="info">
            No assessment data available from the scan. You can skip this step
            and create an assessment later.
          </Alert>
        ) : (
          <SpaceBetween size="m">
            <SpaceBetween direction="horizontal" size="xs">
              <Button
                variant="link"
                iconName={
                  isFilePreviewVisible ? "view-horizontal" : "view-full"
                }
                onClick={() => setIsFilePreviewVisible?.(!isFilePreviewVisible)}
              >
                {isFilePreviewVisible ? "Hide" : "Show"} File Preview
              </Button>
            </SpaceBetween>
            <Grid
              gridDefinition={
                isFilePreviewVisible
                  ? [{ colspan: 6 }, { colspan: 6 }]
                  : [{ colspan: 12 }]
              }
            >
              {isFilePreviewVisible && (
                <Container header={<Header variant="h2">File Preview</Header>}>
                  {scanJobData?.scanJob ? (
                    <FilePreview
                      type={"pdf"}
                      fileName={scanJobData.scanJob.fileName}
                      presignedUrl={downloadUrlData?.url || ""}
                    />
                  ) : (
                    <div>No file available for preview</div>
                  )}
                </Container>
              )}
              <Container
                header={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    {isAssessmentSimplified ? (
                      <Button
                        onClick={() => setIsAssessmentSimplified?.(false)}
                      >
                        Add Assessment
                      </Button>
                    ) : (
                      <Button onClick={() => setIsAssessmentSimplified?.(true)}>
                        Skip Assessment
                      </Button>
                    )}
                  </div>
                }
              >
                {isAssessmentSimplified ? (
                  <Box textAlign="left" color="inherit">
                    <Box variant="p">
                      Create the notice now and add assessment later.
                    </Box>
                  </Box>
                ) : (
                  <AssessmentDetailsStep
                    shortIdForScanJob={shortId}
                    isScanWizard={true}
                    currencySign="$"
                    category="notice"
                    control={control}
                  />
                )}
              </Container>
            </Grid>
          </SpaceBetween>
        ),
      },
    ],
  };
};
